import { Content } from './Content';
import { BackgroundPage } from '@/components/Layout/BackgroundPage';

export function Login() {
	return (
		<BackgroundPage>
			<Content />
		</BackgroundPage>
	);
}
